// DVH (Dose Volume Histogram) data model and related types

export type CurveData = {
    data: { x: number; y: number }[];
    color: string;
    name: string;
    visible: boolean;
    doseMaxGy: number;
    doseMinGy: number;
    doseMeanGy: number;
    roiNumber: number;
    structureVolumeCm3?: number;
};

export class Dvh {
    public readonly dvhData: Float64Array; // DVH data, amount of cumulated structure volume at each bin
    public readonly binWidth: number; // Width of each bin in Gy
    public readonly doseMaxGy: number; // Maximum dose in Gy
    public readonly doseMinGy: number; // Minimum dose in Gy
    public readonly doseMeanGy: number; // Mean dose in Gy
    public readonly structureVolumeCm3?: number;

    constructor(
        dvhData: Float64Array,
        binWidth: number,
        doseMaxGy: number,
        doseMinGy: number,
        doseMeanGy: number,
        structureVolumeCm3?: number
    ) {
        this.dvhData = dvhData;
        this.binWidth = binWidth;
        this.doseMaxGy = doseMaxGy;
        this.doseMinGy = doseMinGy;
        this.doseMeanGy = doseMeanGy;
        this.structureVolumeCm3 = structureVolumeCm3;
    }
}
